export default __webpack_public_path__ + "static/media/coupon-icon.10f13091.svg";